import React, { Component } from 'react';
import Slide from '@material-ui/core/Slide';
import ReactDOM from 'react-dom';

import '../../chat.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SpeechBubble from './speechBubble/SpeechBubble';
import MessageTypeEnum from '../../config/constants/MessageTypeEnum';
import LineBreakTypeEnum from "../../config/constants/LineBreakTypeEnum";
import {Carousel} from "react-responsive-carousel";
import VizSensor from 'react-visibility-sensor';
import {CircularProgress} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import LayoutTypeEnum from "../../config/constants/LayoutTypeEnum";

/**
 * Class for the chatfield containing the speechbubbles.
 */
class ChatBotChatField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastChatFieldContentHeight: 0,
            scrollToOldHeight: false,
            loadMoreEnabled: false
        };
    }

    /*
     * Returns a speechbubble that shows a user or bot is writing.
     */
    getIsWritingSpeechBubble = (isUser) => {
        return  {
            messageList: [
                {
                    messageType: MessageTypeEnum.text,
                    content: '<div class="bot-writing-message">' +
                        '<span></span><span></span><span></span>' +
                        '</div>'
                }
            ],
            index: 0,
            isUser: isUser,
            botWriting: true
        };
    };

    /**
     * Scrolls to the bottom of the chatfield.
     */
    scrollToBottom = () => {
        if (this.messagesEnd) {
            this.messagesEnd.scrollIntoView({behavior: 'smooth'});
        }
    };

    getChatFieldContentHeight= () => {
        // Checks if Internet Explorer
        const ua = window.navigator.userAgent;
        const isIe = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;

        if (!this.chatFieldContentDiv) {
            return null;
        }

        return isIe ? this.chatFieldContentDiv.scrollHeight : this.chatFieldContentDiv.clientHeight;
    };

    /**
     * Loads more chat messages when start of messages div is scrolled into view.
     */
    handleLoadMoreVisibilityChange = (isVisible) => {
        if (isVisible && this.state.loadMoreEnabled)
        {
            this.setState({lastChatFieldContentHeight: this.getChatFieldContentHeight(), scrollToOldHeight: true}, () => {
                this.props.loadMoreSpeechBubble();
            });
        }
    };



    /**
     * Checks every 200 ms if the height of the chatfield has changed and scrolls top the bottom if it has.
     * This fix is because of componentDidUpdate() does not get called if for example 
     * a height change is caused by a youtube video initializing in a child component.
     */

    componentDidMount = () => {
        const that = this;

        setInterval(() => {
            if (that.chatFieldContentDiv == null) {
                return;
            }

            const chatFieldContentHeight = this.getChatFieldContentHeight();

            if (chatFieldContentHeight && chatFieldContentHeight !== that.state.lastChatFieldContentHeight) {

                if (that.state.loadMoreEnabled === false) {
                    setTimeout(() => {
                        this.setState({loadMoreEnabled: true});
                    }, 1000)
                }

                if (this.props.loadToEnd) {
                    that.scrollToBottom();

                } else if (this.state.scrollToOldHeight) {
                    that.chatFieldParentContainerDiv.scrollTop = chatFieldContentHeight - that.state.lastChatFieldContentHeight;
                }

                that.setState({lastChatFieldContentHeight: chatFieldContentHeight, scrollToOldHeight: false});
            }
        }, 200);

        setTimeout(() => {
            this.setState({loadMoreEnabled: true});
        }, 2000);
    };



    /**
     * Returns an array of the rows of speechbubbles.
     * Here continuous suggestions from the same response is added to the same rows.
     * @returns {[]|Array}
     */
    getSpeechBubbleRowList = () => {
        if (!this.props.speechBubbleList) {
            return [];
        }

        let rowList = [];
        let row = [];
        this.props.speechBubbleList.forEach((speechBubble, index, array) => {
            if (!speechBubble.hidden) {
                row.push(speechBubble);
            }

            const flex = (index + 1 <= array.length - 1) &&
                speechBubble.chatResponseId != null && array[index + 1].chatResponseId != null &&
                (speechBubble.chatResponseId === array[index + 1].chatResponseId) &&
                ((speechBubble.suggestion != null && array[index + 1].suggestion != null) ||
                    (speechBubble.lineBreakType !== LineBreakTypeEnum.notSet &&
                        speechBubble.lineBreakType !== LineBreakTypeEnum.newLine &&
                        speechBubble.lineBreakType === array[index + 1].lineBreakType));

            if (flex === false) {
                if (row.length > 0) {
                    rowList.push(row);
                }

                row = [];
            }
        });

        return rowList;
    };

    renderSpeechBubbleRow = (speechBubbleRow) => {
        return (
            speechBubbleRow.map((speechBubble, index) => (
                    speechBubble.hidden ? null :
                        (speechBubble.messageList.every((message) => {
                            return message.hidden === true;
                        }) ? null :
                            <Slide  direction={speechBubble.isUser ? 'left' : 'right'} in={true} key={index}>
                                <SpeechBubble token={this.props.token} showAvatar={true}  speechBubble={speechBubble} chatConfig={this.props.chatConfig}
                                              sendMessage={this.props.sendMessage} sendIntent={this.props.sendIntent}
                                              sendChatResponseFeedback={this.props.sendChatResponseFeedback}
                                              spectatorMode={this.props.spectatorMode} language={this.props.language}
                                              welcomePreviewEnabled={this.props.welcomePreviewEnabled}
                                              layoutMode={LayoutTypeEnum.chatBot}
                                />
                            </Slide>)
                ))
        )
    };

    render() {

        const speechBubbleRowList = this.getSpeechBubbleRowList();

        return(

                <div id={'chat-field-container-parent'} ref={(div) => this.chatFieldParentContainerDiv = div}>
                    {this.state.scrollToOldHeight ?
                        <div id={'chat-field-load-container'}>
                            <LinearProgress />
                        </div> : null
                    }
                    <div id={'chat-field-content-container'} ref={(div) => this.chatFieldContentDiv = div}>
                        {this.props.loadMore && speechBubbleRowList.length > 0 ?
                            <VizSensor onChange={this.handleLoadMoreVisibilityChange}>
                                <div style={{width: '100%', height: '1px'}}/>
                            </VizSensor> : null
                        }

                        {speechBubbleRowList.map((speechBubbleRow, index) => (
                            <div
                                className={speechBubbleRow[0].suggestion == null ? 'chat-field-speechbubble-row' : 'chat-field-suggestion-speechbubble-row'}
                                key={index}>
                                {speechBubbleRow[0].lineBreakType === LineBreakTypeEnum.carousel ?
                                    <Carousel useKeyboardArrows centerMode autoPlay showArrows={true}
                                              showThumbs={false} showStatus={false} centerSlidePercentage={85}
                                              className={'speech-bubble-carousel-slide'}>
                                        {this.renderSpeechBubbleRow(speechBubbleRow)}
                                    </Carousel> :

                                    this.renderSpeechBubbleRow(speechBubbleRow)
                                }
                            </div>
                        ))}

                        {this.props.botWriting ?
                            (
                                <SpeechBubble token={this.props.token}
                                              showAvatar={(this.props.speechBubbleList.length === 0 ? true :
                                                      (this.props.speechBubbleList[this.props.speechBubbleList.length - 1].isUser === true)
                                              )} speechBubble={this.getIsWritingSpeechBubble(false)}
                                              chatConfig={this.props.chatConfig}
                                              language={this.props.language}
                                              layoutMode={LayoutTypeEnum.chatBot}
                                />
                            )
                            : null}

                        {this.props.userWriting ?
                                <SpeechBubble token={this.props.token}
                                              speechBubble={this.getIsWritingSpeechBubble(true)}
                                              chatConfig={this.props.chatConfig} language={this.props.language}
                                              layoutMode={LayoutTypeEnum.chatBot}
                                />
                            : null}

                        <div style={{float: 'left', clear: 'both'}}
                             ref={(el) => {
                                 this.messagesEnd = el;
                             }}>
                        </div>
                    </div>
                </div>

        );
    }
}

export default ChatBotChatField;
